import { createSlice } from '@reduxjs/toolkit';
import { LABELINGCHIMP_SAM_API, OMSAPI,INTEGRATIONS_API } from '../../../API';


export const trackingEventsSlice = createSlice({
    name: 'Tracking',
    initialState: {
        tracking: {},
        loading: false,
        meta: [],
        hasErrors: false,
        showSlider: false,
        notification: { show: false, messageContent: "", messageType: "success" }
    },
    reducers: {
        getTrackingDetail: (state) => {
            return {
                ...state,
                loading: true,
                showSlider: true
            }
        },
        getTrackingDetailSuccess: (state, action) => {
            return {
                ...state,
                tracking: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: action && action.payload && action.payload.data  && action.payload.data.meta, messageType: "success" },
                showSlider: true
            }
        },
        getTrackingDetailFailure: (state, action) => {
            // 1. Robust status detection: Check payload status, then root action status
            const status = action?.payload?.status || action?.status; 
            const meta = action?.payload?.data?.meta;
            const payloadData = action?.payload?.data;

            let displayMessage = "";

            // 2. Identify 500 error even with a missing payload structure
            if (status === 500 || !action?.payload) {
                displayMessage = "Internal Server Error. Our team has been notified. Please try again later.";
            } else {
                // Standard handling for 422/Carrier errors
                displayMessage = meta?.message || payloadData?.message || "Unable to retrieve tracking details";
            }

            return {
                ...state,
                loading: false,
                notification: { 
                    show: true, 
                    messageContent: displayMessage,
                    // Try to find tracking_number in any available path
                    tracking_number: meta?.tracking_number || payloadData?.tracking_number || "", 
                    status: status || 500, // Default to 500 if the failure reached here without payload
                    messageType: "error" 
                },
                tracking: {},
                hasErrors: true
            };
        },
        getCustomerDetail: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        getCustomerDetailSuccess: (state, action) => {
            return {
                ...state,
                tracking:
                action &&
                action.payload &&
                action.payload.data &&
                action.payload.data.data,
                hasErrors: false,
                loading: false,
            };
        },
        getCustomerDetailFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                tracking: {},
            };
        },
        resetTrackingNotification: (state, action) => {
            return {
                ...state,
                tracking: {},
                meta:[],
                notification: { show: false, messageContent: "", messageType: "success" }
            }
        }
    }
})
export const { getTrackingDetail, getTrackingDetailSuccess, getTrackingDetailFailure,getCustomerDetail,getCustomerDetailSuccess,getCustomerDetailFailure, resetTrackingNotification } = trackingEventsSlice.actions;


export const fetchTrackingDetail = (data, apikey) => dispatch => {
    const qs = Object.keys(data)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
        .join('&');
    dispatch(getTrackingDetail());
    let trackingNumber = ""
    if("tracking_number" in data){
        trackingNumber = data["tracking_number"];
    }
    dispatch(updateTrackingDetail(trackingNumber, apikey));
    try {
        LABELINGCHIMP_SAM_API.get('/track?' + qs, {
            crossDomain: true,
            headers: {
                "x-api-key": apikey
            }
        })
            .then(function (response) {
                dispatch(getTrackingDetailSuccess(response));
            })
            .catch(function (error) {
                dispatch(getTrackingDetailFailure(error.response));
            });
    } catch (error) {
        dispatch(getTrackingDetailFailure(error));
    }
};


export const fetchCustomerDetails = (data,apikey) => (dispatch) => {
  const qs = Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&");
  dispatch(getCustomerDetail());
  try {
    INTEGRATIONS_API.get("/internal/find-user?" + qs, {
      crossDomain: true,
      headers: {
        "x-api-key": apikey,
      },
    })
      .then(function (response) {
        const final_data = {
            "tracking_number": response && response.data && response.data.data && response.data.data.tracking_number,
            "shipment_id": response && response.data && response.data.data && response.data.data.shipment_id,
            "carrier_name": response && response.data && response.data.data && response.data.data.carrier_name,
            "request_medium":"UI",
          };
        dispatch(getCustomerDetailSuccess(response));
        dispatch(fetchTrackingDetail(final_data,apikey))
      })
      .catch(function (error) {
        const final_data = { "carrier_auto_detect": true, 'tracking_number':  data.tracking_number,"request_medium":"UI", }
        dispatch(getCustomerDetailFailure(error.response));
        dispatch(fetchTrackingDetail(final_data,apikey))
      });
  } catch (error) {
    const final_data = { "carrier_auto_detect": true, 'tracking_number': data.tracking_number,"request_medium":"UI" }
    dispatch(getCustomerDetailFailure(error));
    dispatch(fetchTrackingDetail(final_data,apikey))
  }
};

export const updateTrackingDetail = (trackingNumber, apikey) => dispatch => {
    OMSAPI.get('/track/' + trackingNumber, {
        crossDomain: true,
        headers: {
            "x-api-key": apikey
        }
    })
};

export const resetTrackingEventNotification = data => dispatch => {
    dispatch(resetTrackingNotification());
}


export default trackingEventsSlice.reducer;
